'use client';

import { c as _c } from "react/compiler-runtime";
import './child-bio.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildBioDetails } from '../../../molecules/child-bio-details/child-bio-details.tsx';
import { ChildBioImage } from '../../../molecules/child-bio-image/child-bio-image.tsx';
import { ChildBioDisplayVariants } from '../../../utils/child-bio.ts';
export const ChildBioDisplay: React.FC<{
  details: ChildDetails;
  availability: ChildAvailabilityItem;
  seoLevel?: number;
  variant: ChildBioDisplayVariants;
}> = t0 => {
  const $ = _c(20);
  const {
    seoLevel: t1,
    details,
    availability,
    variant
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  const isSticky = variant === ChildBioDisplayVariants.STICKY;
  let t2;
  if ($[0] !== isSticky) {
    t2 = cn("ChildBio__flex flex", {
      "ChildBio__flex--sticky": isSticky
    });
    $[0] = isSticky;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== availability || $[3] !== details || $[4] !== isSticky) {
    t3 = <div className="ChildBio__media"><ChildBioImage details={details} availability={availability} fullWidth={isSticky} /></div>;
    $[2] = availability;
    $[3] = details;
    $[4] = isSticky;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isSticky) {
    t4 = cn("ChildBio__content", {
      "px-comfy-sm": isSticky
    });
    $[6] = isSticky;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== availability || $[9] !== details || $[10] !== isSticky || $[11] !== seoLevel) {
    t5 = <ChildBioDetails seoLevel={seoLevel} details={details} availability={availability} isSticky={isSticky} />;
    $[8] = availability;
    $[9] = details;
    $[10] = isSticky;
    $[11] = seoLevel;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};